import { RangePickerProps } from 'antd/lib/date-picker';
import moment, { type Moment } from 'moment-timezone';

moment.tz('Etc/UTC');
export default moment;

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const LONG_DATE_FORMAT = 'ddd MMM DD YYYY HH:mm:ss';

export const getDate = (dateString?: string, format = DEFAULT_DATE_FORMAT): Moment | null => {
  if (!dateString) return null;
  return moment.utc(dateString, format);
};

export const formatDateString = (dateString: string, format = DEFAULT_DATE_FORMAT, currentFormat?: string): string => {
  if (currentFormat) {
    return moment(dateString, currentFormat).format(format);
  }
  return moment(dateString).format(format);
};

export const toDateString = (date: Moment | string) => {
  if (!date) {
    return '';
  }
  if (typeof date === 'string') {
    return date;
  }
  return date.format('YYYY-MM-DD');
};

export const getCurrentDateString = (format = DEFAULT_DATE_FORMAT, tz = 'UTC'): string => {
  return moment.tz(new Date(), tz).format(format) as string;
};

export const isBeforeToday = (dateMoment: Moment): boolean => {
  const today = moment.utc(new Date(), DEFAULT_DATE_FORMAT);
  return dateMoment.isBefore(today);
};

export const isSameOrAfterToday = (dateMoment: Moment): boolean => {
  const today = moment().utc().startOf('day');
  return dateMoment.isSameOrAfter(today);
};

export const isSameOrBefore = (date: Moment, number: number): boolean => {
  return moment().subtract(number, 'day').startOf('day').isSameOrBefore(date.startOf('day'));
};

export const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  return current && current.isAfter(moment.now());
};
export const disabledDate2: RangePickerProps['disabledDate'] = (current) => {
  // 禁用今天之前的日期
  return current && current < moment().endOf('day');
};
